import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.css']
})
export class ErrorPopupComponent implements OnInit {

  @Input() title: string;
  @Input() visible: string;
  @Input() body_content: string;
  @Input() button_text: string;
  @Output() ok_button_event: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  popupOkAction(){
    this.visible = 'none';
    this.ok_button_event.emit()
  }
}
